import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.MissingChargesNotice.Title',
    defaultMessage: 'Lease Charge Not Created',
  },
  notCreated: {
    id: 'App.MissingChargesNotice.NotCreated',
    defaultMessage:
      // eslint-disable-next-line max-len
      '{count, plural, one {The <b>{charges}</b> monthly charge could not be created for this household because the charge code is not configured for this property.} other {The <b>{charges}</b> monthly charges could not be created for this household because their charge codes are not configured for this property.}}',
  },
  addManually: {
    id: 'App.MissingChargesNotice.AddManually',
    defaultMessage:
      // eslint-disable-next-line max-len
      "{count, plural, one {This monthly charge must be added manually on the household's Lease Data tab.} other {These monthly charges must be added manually on the household's Lease Data tab.}}",
  },
  notifyAdministrator: {
    id: 'App.MissingChargesNotice.NotifyAdministrator',
    defaultMessage: 'Please notify your property administrator.',
  },
  missedForOtherHouseholds: {
    id: 'App.MissingChargesNotice.MissedForOtherHouseholds',
    defaultMessage:
      // eslint-disable-next-line max-len
      "{count, plural, one {Until the property's charge configuration is corrected, this monthly charge will continue to be missed for all other applicable households at this property.} other {Until the property's charge configuration is corrected, these monthly charges will continue to be missed for all other applicable households at this property.}}",
  },
  gotIt: {
    id: 'App.MissingChargesNotice.GotIt',
    defaultMessage: 'Got It',
  },
  petRent: {
    id: 'App.MissingChargesNotice.PetRent',
    defaultMessage: 'Pet Rent',
  },
  shortTermLeaseFee: {
    id: 'App.MissingChargesNotice.ShortTermLeaseFee',
    defaultMessage: 'Short Term Lease Fee',
  },
});

export default messages;
